import { render, staticRenderFns } from "./BaseArrow.vue?vue&type=template&id=b1fe0728&scoped=true&"
import script from "./BaseArrow.vue?vue&type=script&lang=js&"
export * from "./BaseArrow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArrow.vue?vue&type=style&index=0&id=b1fe0728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fe0728",
  null
  
)

export default component.exports